module.exports = __webpack_public_path__ + "static/media/landing-desktop-2x.e3048d9d.jpg";